var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolanaNoBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2170_31372)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.29609 9.09373C3.38351 9.00632 3.5037 8.95532 3.63119 8.95532H15.1921C15.4033 8.95532 15.509 9.21029 15.3596 9.35963L13.0759 11.6434C12.9884 11.7308 12.8682 11.7818 12.7408 11.7818H1.17987C0.968614 11.7818 0.862985 11.5268 1.01232 11.3775L3.29609 9.09373Z",
    fill: "url(#paint0_linear_2170_31372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.29609 0.566877C3.38715 0.47946 3.50735 0.428467 3.63119 0.428467H15.1921C15.4033 0.428467 15.509 0.683433 15.3596 0.83277L13.0759 3.11654C12.9884 3.20395 12.8682 3.25495 12.7408 3.25495H1.17987C0.968614 3.25495 0.862985 2.99998 1.01232 2.85064L3.29609 0.566877Z",
    fill: "url(#paint1_linear_2170_31372)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0759 4.8032C12.9884 4.71579 12.8682 4.66479 12.7408 4.66479H1.17987C0.968614 4.66479 0.862985 4.91976 1.01232 5.0691L3.29609 7.35287C3.38351 7.44028 3.5037 7.49128 3.63119 7.49128H15.1921C15.4033 7.49128 15.509 7.23631 15.3596 7.08697L13.0759 4.8032Z",
    fill: "url(#paint2_linear_2170_31372)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2170_31372",
    x1: 14.0877,
    y1: -0.935733,
    x2: 6.08662,
    y2: 14.3895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2170_31372",
    x1: 10.5892,
    y1: -2.7623,
    x2: 2.58812,
    y2: 12.5629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2170_31372",
    x1: 12.3273,
    y1: -1.85461,
    x2: 4.32623,
    y2: 13.4706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00FFA3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DC1FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2170_31372"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4857,
    height: 11.3533,
    fill: "white",
    transform: "translate(0.943359 0.428467)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolanaNoBackground);
export default __webpack_public_path__ + "static/media/solana-no-background.70d6ef332b31a4e1cbcc99a7404da298.svg";
export { ForwardRef as ReactComponent };